import React from 'react';
import { Box, Grid } from '@mui/material';
import Navbar from '@/components/home/Navbar';
import DocumentPanel from './components/DocumentPanel';
import ChatPanel from './components/ChatPanel';
import LogPanel from './components/LogPanel';

const WorkspacePage: React.FC = () => {
    return (
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f5f5f5' }}>
            <Navbar />
            <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', gap: 0 }}>
                <Grid container sx={{ height: '100%' }}>
                    <Grid item xs={3} sx={{ height: '100%' }}>
                        <DocumentPanel />
                    </Grid>
                    <Grid item xs={5} sx={{ height: '100%' }}>
                        <ChatPanel />
                    </Grid>
                    <Grid item xs={4} sx={{ height: '100%' }}>
                        <LogPanel />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default WorkspacePage;
